import Hardware from 'src/models/hardware/Hardware'
import Model, { encoders, ID, Integer, IsoDateTime, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/model'

export const DAYS_OF_WEEK_FOR_SELECT = [
  {
    value: 0,
    label: 'Sun'
  },
  {
    value: 1,
    label: 'Mon'
  },
  {
    value: 2,
    label: 'Tue'
  },
  {
    value: 3,
    label: 'Wed'
  },
  {
    value: 4,
    label: 'Thu'
  },
  {
    value: 5,
    label: 'Fri'
  },
  {
    value: 6,
    label: 'Sat'
  }
]

export default class HardwareJob extends Model {
  static name = 'HardwareJob'

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      hardware: {
        type: Hardware,
        encode: encoders.hasOne,
        default: null
      },

      jobName: {
        type: String,
        options: ['comscore', 'rosetta', 'cinemanext', 'ncm', 'screenwriter', 'tcc']
      },

      parameters: {
        type: JsonObject,
        default () {
          return {
            days_before: null,
            days_after: null
          }
        }
      },

      remoteHost: {
        type: String
      },
      remoteUser: {
        type: String,
        default: null
      },
      remotePassword: {
        type: String,
        default: null
      },
      tlsEnabled: {
        type: Boolean,
        default: true
      },
      remoteFilename: {
        type: String
      },

      hourOfDay: {
        type: Integer,
        default: 0
      },
      daysOfWeek: {
        type: JsonArray,
        default: null
      },
      daysOfMonth: {
        type: JsonArray,
        default: null
      },
      monthsOfYear: {
        type: JsonArray,
        default: null
      },

      enabled: {
        type: Boolean
      },
      lastErrorMessage: {
        type: String,
        output: true
      },
      lastSentAt: {
        type: IsoDateTime,
        output: true
      },
      action: {
        type: String,
        input: true,
        default: null
      }
    }
  }
}
